import { createContext, useContext } from 'react';
const ColorSwatchLabelPositions = ['top', 'bottom', 'left', 'right'];
const ColorSwatchGradientTypes = ['linear', 'radial'];
const ColorSwatchesContext = /*#__PURE__*/createContext(undefined);
function useColorSwatchesContext() {
  return useContext(ColorSwatchesContext);
}
export { ColorSwatchGradientTypes, ColorSwatchLabelPositions, ColorSwatchesContext, useColorSwatchesContext };